'use strict';

angular.module('app').directive('faqFadeon', function() {
    var link = function(scope, element) {
        var elem = $(element),
            plusContainer = elem.children('span:first-child'),
            toggleSection = elem.next('.fade-onload');

        elem.click(function() {
            toggleSection.slideToggle();

            plusContainer.html(plusContainer.html() === '+' ? '-' : '+');
        });
    };
    return {
        restrict: 'A',
        link: link
    };
});